(() => {
  const resultsList = document.querySelector('results-list[data-is-search-results]');
  if (!resultsList) return;
  
  if (resultsList.dataset.fallbackInitialized === 'true') return;
  resultsList.dataset.fallbackInitialized = 'true';
  
  const sectionId = resultsList.dataset.sectionId || resultsList.getAttribute('section-id');
  if (!sectionId) {
    return;
  }
  
  let clickHandlerAttached = false;
  
  const enableButton = () => {
    const loadMoreButton = resultsList.querySelector('.load-more-button');
    if (!loadMoreButton) return;
    
    const currentPage = parseInt(loadMoreButton.dataset.currentPage || '1');
    const totalPages = parseInt(loadMoreButton.dataset.totalPages || '1');
    
    if (currentPage < totalPages) {
      loadMoreButton.disabled = false;
      loadMoreButton.removeAttribute('disabled');
      loadMoreButton.style.display = 'flex';
    } else {
      loadMoreButton.style.display = 'none';
      loadMoreButton.disabled = true;
      loadMoreButton.setAttribute('disabled', '');
    }
  };
  
  const setupClickHandler = () => {
    if (clickHandlerAttached) return;
    
    const loadMoreButton = resultsList.querySelector('.load-more-button');
    if (!loadMoreButton) return;
    
    clickHandlerAttached = true;
    
    loadMoreButton.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const button = e.target.closest('.load-more-button');
      if (!button || button.classList.contains('loading')) return;
      
      const currentPage = parseInt(button.dataset.currentPage || '1');
      const totalPages = parseInt(button.dataset.totalPages || '1');
      
      if (currentPage >= totalPages) {
        button.disabled = true;
        return;
      }
      
      const nextPage = currentPage + 1;
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      url.searchParams.set('page', nextPage.toString());
      url.hash = '';
      
      button.classList.add('loading');
      button.disabled = true;
      button.style.display = 'none';
      
      try {
        const { sectionRenderer } = await import('@theme/section-renderer');
        
        const pageContent = await sectionRenderer.getSectionHTML(sectionId, true, url);
        const parser = new DOMParser();
        const doc = parser.parseFromString(pageContent, 'text/html');
        
        const grid = resultsList.querySelector('[role="list"]') || resultsList.querySelector('.product-grid');
        if (!grid) {
          return;
        }
        
        const fetchedResultsList = doc.querySelector('results-list');
        if (fetchedResultsList) {
          const fetchedGrid = fetchedResultsList.querySelector('[role="list"]') || fetchedResultsList.querySelector('.product-grid');
          if (fetchedGrid) {
            const newItems = fetchedGrid.querySelectorAll('.product-grid__item');
            
            if (newItems.length > 0) {
              newItems.forEach(item => {
                grid.appendChild(item.cloneNode(true));
              });
              
              button.dataset.currentPage = nextPage.toString();
              
              if (nextPage >= totalPages) {
                button.style.display = 'none';
                button.disabled = true;
                button.setAttribute('disabled', '');
              } else {
                button.disabled = false;
                button.removeAttribute('disabled');
                button.style.display = 'flex';
              }
              
              if (typeof window !== 'undefined' && typeof window.initProductCardSwatches === 'function') {
                window.initProductCardSwatches(grid);
              }
            } else {
              button.style.display = 'none';
            }
          }
        }
      } catch (error) {
        console.error('[SearchResultsFallback] Error loading more results:', {
          error,
          currentPage,
          nextPage,
          totalPages,
          sectionId,
          url: url.toString()
        });
        button.disabled = false;
        button.removeAttribute('disabled');
        button.style.display = 'flex';
      } finally {
        button.classList.remove('loading');
      }
    });
  };
  
  setTimeout(() => {
    enableButton();
    setupClickHandler();
  }, 100);
})();

